import React from "react";

export default function PortalCreditAppointments() {
  return (
    <div className="space-y-4" data-testid="portal-credit-appointments-page">
      <div>
        <h1 className="font-serif text-2xl font-bold text-navy">Credit Repair Appointments</h1>
        <p className="text-gray-500 text-sm mt-0.5">
          Schedule and manage your credit repair appointments below.
        </p>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
        <iframe
          src="https://pulse.scorexer.com/Portal/meeting.jsp?id=9d43fb51-fcee-45ad-a804-51c464627769"
          title="Credit Repair Appointments"
          height="900"
          width="100%"
          style={{ background: "white" }}
          frameBorder="0"
          className="w-full"
        />
      </div>
    </div>
  );
}
